import { createSlice } from "@reduxjs/toolkit";
import { message } from "antd";

const initialState = {
  listPartnerApproval: [],
  isGetPartnerApproval: false,
  isRemovePartner: false,
  isAcceptPartner: false,
  isRejectPartner: false,
  total: 0,
};

export const partnerApprovalSlice = createSlice({
  name: "partner-approval",
  initialState,
  reducers: {
    getPartnerApprovalRequest: (state) => {
      state.isGetPartnerApproval = true;
    },
    getPartnerApprovalSuccess: (state, { payload }) => {
      state.isGetPartnerApproval = false;
      state.listPartnerApproval = payload.data;
      state.total = payload.total;
    },
    getPartnerApprovalFailure: (state) => {
      state.isGetPartnerApproval = false;
    },
    acceptPartnerRequest: (state) => {
      state.isAcceptPartner = true;
    },
    acceptPartnerSuccess: (state, { payload }) => {
      state.isAcceptPartner = false;
      message.success("Accept partner successfully!");
    },
    acceptPartnerFailure: (state) => {
      state.isAcceptPartner = false;
    },
    rejectPartnerRequest: (state) => {
      state.isRejectPartner = true;
    },
    rejectPartnerSuccess: (state, { payload }) => {
      state.isRejectPartner = false;
      message.success("Reject partner successfully!");
    },
    rejectPartnerFailure: (state) => {
      state.isRejectPartner = false;
    },
    removePartnerRequest: (state) => {
      state.isRemovePartner = true;
    },
    removePartnerSuccess: (state, { payload }) => {
      state.isRemovePartner = false;
      message.success("Remove partner successfully!");
    },
    removePartnerFailure: (state) => {
      state.isRemovePartner = false;
    },
  },
});

export const {
  getPartnerApprovalRequest,
  getPartnerApprovalSuccess,
  getPartnerApprovalFailure,
  acceptPartnerRequest,
  acceptPartnerSuccess,
  acceptPartnerFailure,
  rejectPartnerRequest,
  rejectPartnerSuccess,
  rejectPartnerFailure,
  removePartnerRequest,
  removePartnerSuccess,
  removePartnerFailure,
} = partnerApprovalSlice.actions;

export default partnerApprovalSlice.reducer;
